import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import * as platform from '@cloudpivot/platform';
import { FileUploadControl } from "@cloudpivot/form/src/common/controls/file-upload-control";
import { FormLocationControl } from "@cloudpivot/form/src/common/controls/form-location-control";
import common from "@cloudpivot/common/mobile";
import { H3Upload, H3Dialog } from "h3-mobile-vue";
const suffix = ".jpg";
let Upload = class Upload extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.previewVisible = false;
        this.previewImage = "";
        this.fileList = [];
        this.isAddWatermark = false;
        this.locationInfo = "";
        this.changing = false;
        this.showSignsture = false;
        this.filePreviewUrl = "";
    }
    // 打开表单的时候
    mounted() {
        // 如果仅拍照上传且有水印 就使用钉钉去定位
        this.isAddWatermark = !!this.controlOpts.addWatermark;
        if (!this.readonly) {
            this.getLoaction();
        }
    }
    get listType() {
        // 子表中图片上传显示成附件上传样式
        return this.isImage && !this.control.parentKey ? "photo-list" : "file";
    }
    get isOpenPreview() {
        return !this.getIsOpenPreview();
    }
    handleValueChange(value) {
        this.toFilelist(value);
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
            if (this.fileList.some((f) => f.base64)) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.upload.handleRefUpload();
                    }, 500);
                });
            }
        }
        else {
            this.fileList = [];
        }
        this.listenCommand();
    }
    toFilelist(val) {
        if (!val) {
            this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        if (val.some((x) => x.status !== 3 && x.status !== 2)) {
            // this.changing = false;
            return;
        }
        this.fileList = val
            .filter((x) => x.status === 2)
            .map((x, i) => {
            const idx = x.name.indexOf(suffix);
            if (idx > 0) {
                x.name = x.name.substring(0, idx) + i + suffix;
            }
            if (x.status === 2 && x.base64) {
                delete x.base64;
            }
            if (x.response && x.response.data) {
                x.url = this.getDownloadUrl(x.response.data);
            }
            return x;
        });
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    showError(msg) {
        this.$h3.toast.show({
            text: msg,
        });
    }
    getLoaction() {
        if (this.isAddWatermark) {
            FormLocationControl.service.position(undefined, false).then((result) => {
                this.locationInfo = result.address;
            });
        }
    }
    beforeUpload(files) {
        const file = files[0];
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        return true;
    }
    onChange(info, files) {
        console.log("change", info);
        if (this.readonly) {
            return;
        }
        // this.changing = files.some(f => f.status !== 3 && f.status !== 2);
        // file: uid name size respone status type
        // status 1 准备上传 2 已上传 3上传失败 -1正在上传
        const fileList = files.map((f, i) => {
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                status: f.status === -1 ? 1 : f.status,
                base64: f.base64,
                compressBase64: f.compressBase64,
                response: f.response,
            };
        });
        // .filter(f => f.status === 2);
        // .map(f => f.response.data);
        super.onFilesChange(fileList);
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    handleCancel() {
        this.previewVisible = false;
    }
    handlePreview(file) {
        if (file.response) {
            const url = super.getPreviewUrl(file.response.data);
            const ext = this.getExt(file.name);
            if (this.testIamge(ext) && url == "") {
                return;
            }
            if (url) {
                this.filePreviewUrl = url;
                if (window.h5sdk) {
                    window.open(this.filePreviewUrl);
                }
                else {
                    platform.service.openLink(url);
                }
            }
        }
    }
    filedownload(file) {
        // if (utils.Common.isWechat) {
        //   this.showError(`暂不支持下载`);
        //   return;
        // }
        file.response && super.download(file.response.data);
    }
    uploadError(err) {
        if (!err) {
            return;
        }
        let msg = "";
        switch (err) {
            // case 'overQuantity':
            //   this.showError(`一次最多允许上传张`);
            //   break;
            // case 'uploadError':
            //   this.showError(`文件错误`);
            //   break;
            case "overSize":
                msg = this.$t("cloudpivot.form.renderer.tip.overSize", {
                    label: this.limitSize,
                }).toString();
                this.showError(msg);
                break;
            default:
                msg = this.$t("cloudpivot.form.renderer.tip.uploadError").toString();
                this.showError(msg);
                // this.showError('上传失败请重试');
                break;
        }
    }
    destroyed() {
        super.destroyed();
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    created() {
        this.init();
    }
    hideSignsture() {
        this.showSignsture = false;
    }
};
Upload = tslib_1.__decorate([
    Component({
        name: "upload",
        components: {
            H3Upload,
            H3Dialog,
        },
        directives: {
            TransferDom: common.directives.transferDom,
        },
    })
], Upload);
export default Upload;
